import { SvgIcon, SvgIconProps } from '@mineral/core';
import React from 'react';

export const UserSessionExpiredIcon: React.FC<SvgIconProps> =
  React.forwardRef<SVGSVGElement>((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      width="301"
      height="251"
      viewBox="0 0 301 251"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1222_10426)">
        <g clipPath="url(#clip1_1222_10426)">
          <path
            d="M176.409 242.041H55.3668C53.5171 242.041 52.0176 243.538 52.0176 245.384V247.134C52.0176 248.981 53.5171 250.478 55.3668 250.478H176.409C178.258 250.478 179.758 248.981 179.758 247.134V245.384C179.758 243.538 178.258 242.041 176.409 242.041Z"
            fill="#58606E"
          />
          <path
            d="M175.754 243.661H56.1516C54.7637 243.661 53.4327 243.11 52.4513 242.13C51.4699 241.151 50.9185 239.822 50.9185 238.437L24.7529 114.739C24.7529 113.353 25.3043 112.025 26.2857 111.046C27.2671 110.066 28.5981 109.515 29.986 109.515L152.101 127.798C153.489 127.798 154.82 128.349 155.801 129.329C156.783 130.308 157.334 131.636 157.334 133.022L180.883 238.437C180.883 239.804 180.346 241.117 179.387 242.094C178.428 243.071 177.124 243.633 175.754 243.661Z"
            fill="#707A8A"
          />
          <path
            d="M55.7333 238.985L30.876 116.228L152.546 131.899L177.403 238.985H55.7333Z"
            fill="#E8F4FA"
          />
          <path
            d="M245.982 243.06H179.182C177.159 243.06 175.519 244.697 175.519 246.717C175.519 248.736 177.159 250.373 179.182 250.373H245.982C248.006 250.373 249.646 248.736 249.646 246.717C249.646 244.697 248.006 243.06 245.982 243.06Z"
            fill="#707A8A"
          />
        </g>
      </g>
      <path
        d="M240.956 63C271.354 63 296 87.6284 296 118C296 148.372 271.354 173 240.956 173C211.908 173 188.134 150.449 186.136 121.899L198.676 121.898C200.642 143.533 218.811 160.5 240.957 160.5C264.46 160.5 283.5 141.46 283.5 118C283.5 94.54 264.46 75.5 240.957 75.5C224.798 75.5 210.755 84.534 203.581 97.8238L213.821 97.8145C216.407 97.8121 218.506 99.907 218.508 102.493V102.498C218.508 105.083 216.412 107.18 213.827 107.18L213.821 107.18L195.626 107.158L195.626 107.161L186.3 107.147L186.267 79.6288C186.264 77.0431 188.357 74.9444 190.943 74.9413L190.949 74.9413C193.352 74.9413 195.332 76.7503 195.603 79.0808L195.635 79.6288L195.63 86.8903C205.535 72.4633 222.139 63 240.956 63ZM241 88C244.452 88 247.25 90.7982 247.25 94.25V116.815L259.543 129.545C261.781 131.863 261.87 135.464 259.853 137.883L259.388 138.383C257.057 140.634 253.445 140.759 250.972 138.775L250.46 138.318L234.75 122.7V94.25C234.75 90.7982 237.548 88 241 88Z"
        fill="#F78F4A"
      />
      <defs>
        <clipPath id="clip0_1222_10426">
          <rect width="275" height="251" fill="white" />
        </clipPath>
        <clipPath id="clip1_1222_10426">
          <rect
            width="224.788"
            height="140.779"
            fill="white"
            transform="translate(24.8574 109.698)"
          />
        </clipPath>
      </defs>{' '}
    </SvgIcon>
  ));
